import FlexWrapper from '../../layouts/FlexWrapper';
import "./PageContentToggle.scss";

const PageContentToggle = ({ labels, style }) => {
	return (
		<FlexWrapper gap="l" className="page-content-toggle" style={style}>
			{labels && labels.map((label, idx) => {
				return (
					<div key={idx} className={`toggle-label${label.active ? " toggle-label-active" : ""} ${label.disabled ? "toggle-label-disabled" : ""}`} onClick={label.disabled ? null : label.onClick}>
						{label.label}
					</div>
				)
			})}
		</FlexWrapper>
	);
}

export default PageContentToggle;